import { ApolloClient, DataProxy, FetchResult } from '@apollo/client';
import { DELETE_CAMPAIGN_MUTATION } from './mutations/deleteCampaign.newsletter.graphql';
import { UPDATE_CAMPAIGN_MUTATION } from './mutations/updateCampaign.newsletter.graphql';

export const deleteCampaign = async (
  campaign: {
    id: string;
    sections: { id: string; blocks: { id: string }[] }[];
  },
  client: ApolloClient<DataProxy>,
) => {
  await client.mutate({
    mutation: UPDATE_CAMPAIGN_MUTATION,
    variables: {
      where: { id: campaign.id },
      data: {
        sections: {
          update: (campaign.sections || []).map(({ id, blocks }) => ({
            where: { id },
            data: {
              blocks: { delete: blocks.map((block) => ({ id: block.id })) },
            },
          })),
        },
      },
    },
  });

  await client.mutate({
    mutation: UPDATE_CAMPAIGN_MUTATION,
    variables: {
      where: { id: campaign.id },
      data: {
        sections: {
          delete: (campaign.sections || []).map(({ id }) => ({ id })),
        },
      },
    },
  });

  const res: FetchResult = await client.mutate({
    mutation: DELETE_CAMPAIGN_MUTATION,
    variables: {
      where: {
        id: campaign.id,
      },
    },
  });

  return res;
};
